import React, { useState, useEffect } from 'react';
import './CustomerListPage.css';
import customerApi from '../../../services/apiServices/customerApi';
import userApi from '../../../services/apiServices/userApi';
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch } from 'react-redux';
import configService from '../../../services/configService';
import Pagination from '../../../components/common/Pagination/Pagination'; 
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import FilterComponent from '../../../components/admin/FilterComponent/FilterComponent';

import { useNavigate } from "react-router-dom";
import EyeIcon from '../../../components/icons/EyeIcon';
import ConfirmModal from '../../../components/common/Modals/ConfirmModal/ConfirmModal';
import AddUserModal from '../../../components/common/Modals/AddUserModal/AddUserModal';
import { maskCPF } from '../../../components/masks/masks';

const CustomerListPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const [clientSelected, setClientSelected] = useState();
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalCreateOpen, setIsModalCreateOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const quantity = configService.getDefaultNumberOfItemsTable(); 
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchCustomers = async () => {
            dispatch(setLoading(true));
            try {
                const response = await customerApi.getCustomersPaginated({ page, quantity, orderBy, term: searchTerm, include: "User,CustomerType" });
                setItems(response.Results);
                setTotalPages(response.TotalPages);
                setTotalItens(response.TotalCount);
            } catch (error) {
                toast.error('Erro ao buscar os itens.');
            } finally {
                dispatch(setLoading(false));
            }
        };
        fetchCustomers();
    }, [page, quantity, searchTerm, refresh, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const search = ({term} = {}) => {
        setSearchTerm(term);
    }

    const exportFunction = async (term) => {
        try {
            dispatch(setLoading(true));
            const response = await customerApi.exportCustomers({ term: term });
            
            if (response.Status === 200 && response.Object) {
                window.open(response.Object, "_blank");
                toast.success('Relatório gerado com sucesso!');
            } else {
                toast.error('Erro ao gerar o relatório');
            }
        } catch (error) {
            toast.error('Erro ao gerar o relatório');
        }
        finally{
            dispatch(setLoading(false));
        }
    };

    const deleteOption = (client) => {
        setClientSelected(client);
        setIsModalDeleteOpen(true);
    }

    const handleYesModalDelete = async (item) => {
        dispatch(setLoading(true));
        try {
            if(item.User.IsActive) {
                await userApi.setInactive(item.User.Id);
            } else {
                await userApi.setActive(item.User.Id);
            }
            
            toast.success('Usuário atualizado com sucesso!');
            setRefresh(prev => !prev);
        } catch (error) {
            toast.error('Error updating client status:' + error);
        } finally {
            dispatch(setLoading(false));
            setIsModalDeleteOpen(false);
        }
      };
    
      const handleNoModalDelete = () =>{
        setIsModalDeleteOpen(false);
      };

    const openItem = (code) => {
        navigate(`${code}`);
    }

    return (
    <div className="container-admin-page">
        <ConfirmModal
            isOpen={isModalDeleteOpen}
            title={'Atenção'}
            message={`Deseja realmente ${clientSelected?.User.IsActive ? 'desativar' : 'ativar'} o usuário ${clientSelected?.User.Email}?`}
            onYes={handleYesModalDelete}
            onNo={handleNoModalDelete}
            yesLabel="Sim"
            noLabel="Não"
            confirmData={clientSelected}
        />
        <AddUserModal isOpen={isModalCreateOpen} closeModal={() => {
            setIsModalCreateOpen(false);
            setRefresh(prev => !prev);
        }}/>
        <div className='title-with-options'>
            <h1>Lista dos Usuários</h1>
            <button className='main-button' onClick={() => setIsModalCreateOpen(true)}>Adicionar novo Usuário Admin</button>
        </div>
        <div className='container-admin-page-filters div-with-border'>
            <h3>Filtros</h3>
            <FilterComponent placeHolder={'Nome | Documento | Email | Id'} showTermFilter={true} submitFilter={search} exportFunction={exportFunction}/>
        </div>
        <div className='container-admin-page-table div-with-border'>
            <div>
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Documento</th>
                            <th>Perfil</th>
                            <th>Criado</th>
                            <th>Atualizado</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {items.map((item) => (
                        <tr key={item.Id}>
                            <td data-label='Id'><span className='option-link' onClick={() => openItem(item.Id)}>{item.User.Id}</span></td>
                            <td data-label='Nome'><span className='option-link' onClick={() => openItem(item.Id)}>{item.User.Name}</span></td>
                            <td data-label='Email'><span className='option-link' onClick={() => openItem(item.Id)}>{item.User.Email}</span></td>
                            <td data-label='Documento'><span className='option-link' onClick={() => openItem(item.Id)}>{maskCPF(item.User.Document1)}</span></td>
                            <td data-label='Perfil'><span className='option-link' onClick={() => openItem(item.Id)}>{item.CustomerType.Id === parseInt(configService.getClientPersonTypeCode()) ? 'Cliente' : 'Administrador'}</span></td>
                            <td data-label='Criado'><span className='option-link' onClick={() => openItem(item.Id)}>{putDateOnPattern(item.Created)}</span></td>
                            <td data-label='Atualizado'><span className='option-link' onClick={() => openItem(item.Id)}>{putDateOnPattern(item.Updated)}</span></td>
                            <td data-label='Status'>
                                <button onClick={() => deleteOption(item)} 
                                disabled={item.CustomerType.Id === parseInt(configService.getClientPersonTypeCode())} 
                                className={item.User.IsActive === 1 ? 'item-active brighten-on-hover clickable' : 'item-inactive brighten-on-hover clickable'}>
                                    {item.User.IsActive === 1 ? 'Ativo' : 'False'}
                                </button>
                            </td>
                            <td><span className='option-link' onClick={() => openItem(item.Id)}><EyeIcon/></span></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <sub>Total de Usuários: {totalItens}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    </div>
    );
};

export default CustomerListPage;
